/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { socialPostStatusSchema } from '../social-post-schema';

const reconciledPostSchema = z.object({
  socialPostId: z.number(),
  status: socialPostStatusSchema,
  statusRaw: z.string().nullable().default(null),
  changed: z.boolean(),
});

export type IReconciledSocialPost = z.infer<typeof reconciledPostSchema>;

const reconcileDataSchema = z.object({
  posts: z.array(reconciledPostSchema),
});

export interface IReconcileSocialPostsV1Data {
  posts: IReconciledSocialPost[];
}

export const reconcileSocialPostsV1ResponseSchema = createApiResponseSchema(
  reconcileDataSchema,
) as z.ZodSchema<IAPI<IReconcileSocialPostsV1Data>>;

export type IReconcileSocialPostsV1Response = IAPI<IReconcileSocialPostsV1Data>;
